export enum UserRole {
  SUPERADMIN = 'SUPERADMIN',
  ADMIN = 'ADMIN',
  DRAFTSMAN = 'DRAFTSMAN',
  OFFICE = 'OFFICE',
  PROJECT_MANAGER = 'PROJECT_MANAGER',
  SALES = 'SALES',
  TECHNICIAN = 'TECHNICIAN',
  INSTALLER = 'INSTALLER',
  CUSTOMER = 'CUSTOMER',
  SUPPLIER = 'SUPPLIER',
  PARTNER = 'PARTNER',
  MANAGER = 'MANAGER',
  DEVELOPER = 'DEVELOPER',
  SUPERINTENDENT = 'SUPERINTENDENT',
  FOREMAN = 'FOREMAN',
  ESTIMATOR = 'ESTIMATOR',
  ARCHITECT = 'ARCHITECT',
  ENGINEER = 'ENGINEER',
  INSPECTOR = 'INSPECTOR',
  SUBCONTRACTOR = 'SUBCONTRACTOR',
  FIELD_WORKER = 'FIELD_WORKER',
  PLANNER = 'PLANNER',
  SAFETY_OFFICER = 'SAFETY_OFFICER',
  QUALITY_CONTROL = 'QUALITY_CONTROL',
  PROCUREMENT = 'PROCUREMENT',
  OTHER = 'OTHER',
  VIEWER = 'VIEWER',
  EMPLOYEE = 'EMPLOYEE',
  CONTRACTOR = 'CONTRACTOR',
}

export enum ProposalStatus {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  SHARED = 'SHARED',
  SIGNED = 'SIGNED',
  REJECTED = 'REJECTED',
  ARCHIVED = 'ARCHIVED',
}

export interface ProposalHistoryEntry {
  _id: string;
  action: 'UPLOADED' | 'UPDATED' | 'DELETED' | 'DOWNLOADED' | 'NOTE_ADDED' | 'SHARED_WITH_CUSTOMER' | 'SIGNED_BY_CUSTOMER' | 'STATUS_CHANGED';
  notes?: string;
  previousStatus?: string;
  newStatus?: string;
  actionBy?: {
    _id: string;
    firstName: string;
    lastName: string;
  } | null;
  actionAt: string;
}

export interface Proposal {
  _id: string;
  name: string;
  description?: string;
  fileName: string;
  originalName: string;
  fileSize: number;
  mimeType: string;
  fileUrl?: string;
  downloadUrl?: string;
  version: number;
  status: ProposalStatus;
  isPrimary: boolean;
  uploadedBy: {
    _id: string;
    firstName: string;
    lastName: string;
  };
  uploadedAt: string;
  sharedWithCustomer: boolean;
  sharedAt?: string;
  signedByCustomer: boolean;
  signedAt?: string;
  signedDocumentUrl?: string;
  auditLogUrl?: string;
  signerEmail?: string;
  signerName?: string;
  notes?: string;
  history: ProposalHistoryEntry[];
}

export enum NotificationType {
  INFO = 'INFO',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
}

export interface IRelatedTo {
  model: string;
  id: string;
}

export interface IUserNotification {
  _id: string;
  message: string;
  read: boolean;
  type: NotificationType;
  relatedTo: IRelatedTo;
  createdAt: string;
}


export enum UserDiscriminator {
    REGULAR,
    CUSTOMER,
    PARTNER,
}
export interface BaseUser {
  _id: string;
  id: string;
  email: string;
  lastName: string;
  discriminator: UserDiscriminator;
}

export interface IUser extends BaseUser {
  discriminator: UserDiscriminator.REGULAR;
  firstName: string;
  phone?: string;
  company: string;
  isActive: boolean;
  lastLogin?: string;
  notifications: IUserNotification[];
  createdAt: string;
  updatedAt: string;
  fullName?: string;
  companyData: {
    name: string;
    _id: string;
  };
  isEmailVerified?: boolean;
  /**
   * APP-LEVEL global admin flag.
   * When true, user has access to superadmin panel and all resources.
   * Set manually in database.
   */
  superAdmin?: boolean;
  /**
   * User's permissions array from their roleRef.
   * Returned by login endpoint for frontend permission checks.
   */
  permissions?: string[];
}

export interface CustomerProject {
  _id: string;
  name: string;
}

export interface CustomerUser extends BaseUser {
  discriminator: UserDiscriminator.CUSTOMER;
  name: string;
  phone: string;
  projects: CustomerProject[];
  role: UserRole.CUSTOMER;
}

export interface PartnerCompany {
  _id: string;
  name: string;
}

export interface PartnerUser extends BaseUser {
  discriminator: UserDiscriminator.PARTNER;
  companyName: string;
  contactName?: string;
  phone?: string;
  currentCompanyId: string;
  currentCompanyName: string;
  role: UserRole.PARTNER;
}

export interface IAuthUser {
  user: IUser | CustomerUser | PartnerUser;
  token: string;
}

export interface PartnerLoginResponse {
  partner: PartnerUser;
  companies: PartnerCompany[];
  token: string;
}

export interface CustomerLoginResponse { 
  customer: CustomerUser;
  token: string;
}

export interface VerifyEmailResponse {
  success: boolean;
  message: string;
  data?: {
    user?: {
      email: string;
      isEmailVerified: boolean;
    };
  };
}

export interface ResendVerificationResponse {

}
